import Vue from "vue";
import Pusher from "pusher-js";

Pusher.logToConsole = process.env.NODE_ENV !== "production";
window.Pusher = Pusher;
